import { useAppDispatch, useAppSelector } from 'hooks/redux';
import Slider from 'rc-slider';
import { setCurrentDate } from 'shared/reducers/animationSlice';

const AnimationSlider = () => {
  const dispatch = useAppDispatch();
  const start = useAppSelector(({ animation }) => animation.start);
  const end = useAppSelector(({ animation }) => animation.end);
  const animationState = useAppSelector(({ animation }) => animation.animationState);
  const currentDate = useAppSelector(({ animation }) => animation.currentDate);

  if (!start || !end) {
    return null;
  }

  const onChange = (value: number | number[]) => {
    if (!Array.isArray(value)) {
      dispatch(setCurrentDate(value));
    }
  };

  const minValue = start.valueOf();
  const maxValue = end.valueOf();

  const value = currentDate ?? minValue;

  const isDisabled = animationState === 'disabled';

  return (
    <Slider
      className="rc-animation-slider"
      min={minValue}
      max={maxValue}
      step={1000}
      value={value}
      onChange={onChange}
      disabled={isDisabled}
      styles={{
        track: {
          backgroundColor: 'var(--slider-primary-handle-background-color)',
          height: '8px',
        },
        rail: {
          backgroundColor: 'var(--color-bluegrey-850)!important',
          height: '8px',
        },
        handle: {
          borderColor: 'var(--slider-primary-handle-background-color)',
          backgroundColor: 'var(--slider-primary-handle-background-color)',
          height: 18,
          width: 18,
          marginTop: -5,
        },
      }}
    />
  );
};

export default AnimationSlider;
